module.exports = __webpack_public_path__ + "mk.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/mk.svg
// module id = 945
// module chunks = 0